<template>
    <div class="main">
        <my-echarts ref="chart" :data="data" :barData="barData" :play="animate" waitFor :animation="animate"></my-echarts>
    </div>
</template>
<script>
    import myEcharts from "../echarts";
    import Config from "../echarts/mixin.js";
    export default {
        mixins: [Config],
        components: {
            myEcharts,
        },
        props: {
            barData: {
                type: [Array, Object]
            },
            title: {
                type: String,
                default: '年保有量渗透率 (占终端)'
            },
            name1: {
                type: String,
                default: '智能电视'
            },
            name2: {
                type: String,
                default: '传统电视'
            },
            animate: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            data() {
                let _this = this;
                let color = ["#048DFC", "#2EE6A8"];
                let json = {
                    data: [
                        [8, 12, 17, 24, 29, 36, 41, 46, 49, 53],
                        [92, 88, 83, 76, 71, 64, 59, 54, 51, 47]
                    ],
                    xData: [
                        "2013",
                        "2014",
                        "2015",
                        "2016",
                        "2017",
                        "2018",
                        "2019",
                        "2020",
                        "2021",
                        "2022"
                    ]
                };
                return Object.assign({}, {
                    color: color,
                    tooltip: {
                        show: this.animate ? true : false,
                        padding: [0],
                        backgroundColor: "rgba(0, 0, 0, 0.7)",
                        //transitionDuration: 1,
                        confine: true,
                        // 固定在顶部
                        //position: [178, 10],
                        // position: function(point, params, dom, rect, size) {
                        //   return [point[0] + 20, 6];
                        // },
                        position: function(pos, params, dom, rect, size) {
                            var obj = { top: 6 };
                            // （1）跟随滑动
                            // let boor = pos[0] < size.viewSize[0] / 2;
                            // if (boor) {
                            //   obj["left"] = pos[0] + 20;
                            // } else {
                            //   obj["left"] = pos[0] - 240 - 20;
                            // }
                            // （2）鼠标在左侧时 tooltip 显示到右侧，鼠标在右侧时 tooltip 显示到左侧。
                            //obj[["left", "right"][+(pos[0] < size.viewSize[0] / 2)]] = 5;
                            let boor = pos[0] < size.viewSize[0] / 2 + 20;
                            if (boor) {
                                obj["right"] = 5;
                            } else {
                                obj["left"] = 46;
                            }
                            return obj;
                        },
                        formatter: function(value, index) {
                            return `
                                <div class='permeabilityEchartsTooltipStyle'>
                                  <p>${value[0].name}${_this.title}</p>
                                  <div>
                                    <section>
                                      <div style='background:${color[0]}'>bar</div>
                                      <p>${_this.name1}</p>
                                      <span>${value[0].value}%</span>
                                    </section>
                                    <section>
                                     <div style='background:${color[1]}'>bar</div>
                                      <p>${_this.name2}</p>
                                      <span>${value[1].value}%</span>
                                    </section>
                                  </div>
                                </div>`;
                        }
                    },
                    series: [
                        {
                            data: json.data[0],
                            type: "bar",
                            barWidth: "8",
                            animationDelay: idx => {
                                return this.getAnimationDelay(idx);
                            }
                        },
                        {
                            data: json.data[1],
                            type: "bar",
                            barWidth: "8",
                            animationDelay: idx => {
                                return this.getAnimationDelay(idx);
                            }
                        }
                    ],
                    xAxis: {
                        axisLabel: {
                            color: "rgba(255,255,255,0.75)",
                            fontSize: 13,
                            fontFamily: "AgencyFB-Reg"
                        },
                        data: json.xData,
                        axisPointer: {
                            show: this.animate ? true : false,
                            value: "2001",
                            snap: this.animate ? true : false,
                            lineStyle: {
                                color: "rgba(0, 78, 82,1)",
                                opacity: 0.5,
                                width: 25
                            },
                            label: {
                                show: false
                            },
                            z: 1
                        }
                    },
                    yAxis: {
                        type: "value",
                        axisLabel: {
                            color: "rgba(255,255,255,0.75)",
                            fontSize: 13,
                            fontFamily: "AgencyFB-Reg",
                            align: "left",
                            padding: [0, 0, 0, -25],
                            margin: 18,
                            formatter: function(value, index) {
                                let newValue = value;
                                if (value) {
                                    newValue = newValue + "%";
                                }
                                return newValue;
                            }
                        },
                        splitLine: {
                            show: false
                        },
                        max: 100
                    },
                    grid: {
                        left: 0,
                        bottom: 0,
                        top: 16,
                        right: 0
                    }
                })
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.resizeChart = this.$refs.chart.resizeChart;
            });
        }
    };
</script>
<style scoped lang='less'>
    .main {
        height: 100%;
        padding: 10px 0 0px;
        width: 100%;
    }
</style>
<style lang="less">
    .permeabilityEchartsTooltipStyle {
        width: 240px;
        height: 120px;
        border: 1px solid rgba(3, 138, 248, 0.45);
        box-shadow: 0 4px 16px 0 #000000, inset 0 1px 30px 0 rgba(4, 141, 252, 0.5);
        padding: 15px 16px;
        & > p {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #ffffff;
            letter-spacing: 0;
            line-height: 24px;
            padding-bottom: 12px;
        }
        & > div {
            section {
                float: left;
                width: 96px;
                & > div {
                    width: 16px;
                    height: 4px;
                    font-size: 0;
                }
                p {
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    color: rgba(255, 255, 255, 0.75);
                    letter-spacing: 0;
                    line-height: 22px;
                    padding-top: 4px;
                }
                span {
                    font-family: AgencyFB-Reg;
                    font-size: 20px;
                    color: #ffffff;
                    letter-spacing: 0;
                    line-height: 28px;
                    display: inline-block;
                }
            }
        }
    }
</style>